/**
 * Arthaus gallery-walk page transitions (Phase 10, HD-SYS-TRANS)
 * docs/storefront-redesign/requirements/10_high_design/TECHNICAL_SPECIFICATION.md §12
 *
 * Cross-document View Transitions: the opt-in @view-transition rule is emitted by
 * snippets/hd-flags.liquid only when the flag is on. This script names the ONE element
 * that should morph between pages, just in time, because view-transition-name must
 * be unique per page and a grid holds dozens of cards:
 *
 *   card image  ──►  PDP hero   (clicked [data-card][data-handle] ► [data-hd-vt-hero])
 *   PDP hero    ──►  card image (back navigation, same handle)
 *
 * Everything else cross-dissolves (root). Browsers without cross-document View
 * Transitions (Firefox, older Safari) simply navigate; nothing here runs.
 * Reduced motion: the @view-transition rule sits inside a no-preference media query.
 */
(function () {
  'use strict';
  if (!('onpagereveal' in window)) return;

  var KEY = 'hd-vt-handle';
  var NAME = 'hd-art';
  var MORPH_TO_PDP = true; // the PDP hero <img> carries [data-hd-vt-hero]; see pageswap

  function disabled() {
    if (!document.documentElement.hasAttribute('data-hd-transitions')) return true; // ?hd=-transitions
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function store(v) { try { if (v) sessionStorage.setItem(KEY, v); else sessionStorage.removeItem(KEY); } catch (e) {} }
  function read() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }
  function handleFromUrl(url) {
    var m = url && url.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function cardImage(handle) {
    if (!handle || !window.CSS || !CSS.escape) return null;
    var card = document.querySelector('[data-card][data-handle="' + CSS.escape(handle) + '"]');
    return card && card.querySelector('img');
  }
  function heroImage(handle) {
    if (!handle || !window.CSS || !CSS.escape) return null;
    return document.querySelector('[data-hd-vt-hero="' + CSS.escape(handle) + '"]');
  }
  function name(el, vt) {
    if (!el) return;
    el.style.viewTransitionName = NAME;
    vt.finished.finally(function () { el.style.viewTransitionName = ''; });
  }
  function visible(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight && r.width > 0;
  }

  // Outgoing page: name the element that is about to morph.
  window.addEventListener('pageswap', function (e) {
    if (!e.viewTransition) return;
    if (disabled()) { e.viewTransition.skipTransition(); return; }
    var to = e.activation && e.activation.entry && e.activation.entry.url ? new URL(e.activation.entry.url) : null;
    var toHandle = to && handleFromUrl(to);
    var here = handleFromUrl(location);
    var el = null;
    // With MORPH_TO_PDP off, card ⇄ PDP navigations only cross-dissolve.
    if (toHandle && !MORPH_TO_PDP) el = null;
    else if (toHandle) el = cardImage(toHandle);    // card → PDP
    else if (here) el = heroImage(here);            // PDP → back to a grid
    if (el && visible(el)) {
      store(toHandle || here);
      name(el, e.viewTransition);
    } else {
      store(null);
    }
  });

  // Incoming page: name its matching element so the browser can pair them.
  window.addEventListener('pagereveal', function (e) {
    if (!e.viewTransition) return;
    if (disabled()) { e.viewTransition.skipTransition(); return; }
    var handle = read();
    store(null);
    if (!handle) return;                             // plain cross-dissolve
    var el = heroImage(handle) || cardImage(handle);
    if (!el || !visible(el)) return;
    name(el, e.viewTransition);
    // The PDP hero wrapper has its own 420ms fade-in (data-reveal). When the artwork is
    // morphing into it, the morph IS the entrance: reveal the wrapper at once so the morph
    // lands on a visible target instead of an opacity-0 box. Only on a morph arrival —
    // the hero's fade is untouched on every other load.
    var wrap = el.closest && el.closest('[data-reveal]');
    if (wrap) wrap.classList.add('is-revealed');
  });
})();
